import { IconProps } from 'almanac-ui/icons/Types'

export const Earth = ({ size = 12, color = 'currentColor' }: IconProps) => (
  <svg viewBox="0 0 16 16" width={size} height={size} fill={color}>
    <title>Shared with Public</title>
    <g fillRule="evenodd" transform="translate(-448 -544)">
      <g>
        <path
          d="M109.5 408.5c0 3.23-2.04 5.983-4.903 7.036l.07-.036c1.167-1 1.814-2.967 2-3.834.214-1 .303-1.3-.5-1.96-.31-.253-.677-.196-1.04-.476-.246-.19-.356-.59-.606-.73-.594-.337-1.107.11-1.954.223a2.666 2.666 0 0 1-1.15-.123c-.007 0-.007 0-.013-.004l-.083-.03c-.164-.082-.077-.206.006-.36h-.006c.086-.17.086-.376-.05-.529-.19-.214-.54-.214-.804-.224-.106-.003-.21 0-.313.004l-.003-.004c-.04 0-.084.004-.124.004h-.037c-.323.007-.666-.034-.893-.314-.263-.353-.29-.733.097-1.09.28-.26.863-.8 1.807-.22.603.37 1.166.667 1.666.5.33-.11.48-.303.094-.87a1.128 1.128 0 0 1-.214-.73c.067-.776.687-.84 1.164-1.2.466-.356.68-.943.546-1.457-.106-.413-.51-.873-1.28-1.01a7.49 7.49 0 0 1 6.524 7.434"
          transform="translate(354 143.5)"
        ></path>
        <path
          d="M104.107 415.696A7.498 7.498 0 0 1 94.5 408.5a7.48 7.48 0 0 1 3.407-6.283 5.474 5.474 0 0 0-1.653 2.334c-.753 2.217-.217 4.075 2.29 4.075.833 0 1.4.561 1.333 2.375-.013.403.52 1.78 2.45 1.89.7.04 1.184 1.053 1.33 1.74.06.29.127.65.257.97a.174.174 0 0 0 .193.096"
          transform="translate(354 143.5)"
        ></path>
        <path
          fillRule="nonzero"
          d="M110 408.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0z"
          transform="translate(354 143.5)"
        ></path>
      </g>
    </g>
  </svg>
)

export const LikeReact = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z"
      fill="url(#paint0_linear_15251_63610)"
    />
    <path
      d="M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z"
      fill="url(#paint1_radial_15251_63610)"
    />
    <path
      d="M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z"
      fill="url(#paint2_radial_15251_63610)"
      fillOpacity=".5"
    />
    <path
      d="M7.3014 3.8662a.6974.6974 0 0 1 .6974-.6977c.6742 0 1.2207.5465 1.2207 1.2206v1.7464a.101.101 0 0 0 .101.101h1.7953c.992 0 1.7232.9273 1.4917 1.892l-.4572 1.9047a2.301 2.301 0 0 1-2.2374 1.764H6.9185a.5752.5752 0 0 1-.5752-.5752V7.7384c0-.4168.097-.8278.2834-1.2005l.2856-.5712a3.6878 3.6878 0 0 0 .3893-1.6509l-.0002-.4496ZM4.367 7a.767.767 0 0 0-.7669.767v3.2598a.767.767 0 0 0 .767.767h.767a.3835.3835 0 0 0 .3835-.3835V7.3835A.3835.3835 0 0 0 5.134 7h-.767Z"
      fill="#fff"
    />
    <defs>
      <radialGradient
        id="paint1_radial_15251_63610"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(90 .0005 8) scale(7.99958)"
      >
        <stop offset=".5618" stopColor="#0866FF" stopOpacity="0" />
        <stop offset="1" stopColor="#0866FF" stopOpacity=".1" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_15251_63610"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(45 -4.5257 10.9237) scale(10.1818)"
      >
        <stop offset=".3143" stopColor="#02ADFC" />
        <stop offset="1" stopColor="#02ADFC" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint0_linear_15251_63610"
        x1="2.3989"
        y1="2.3999"
        x2="13.5983"
        y2="13.5993"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02ADFC" />
        <stop offset=".5" stopColor="#0866FF" />
        <stop offset="1" stopColor="#2B7EFF" />
      </linearGradient>
    </defs>
  </svg>
)

export const HeartReact = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g clipPath="url(#clip0_15251_63610)">
      <path
        d="M15.9963 8c0 4.4179-3.5811 7.9993-7.9986 7.9993-4.4176 0-7.9987-3.5814-7.9987-7.9992 0-4.4179 3.5811-7.9992 7.9987-7.9992 4.4175 0 7.9986 3.5813 7.9986 7.9992Z"
        fill="url(#paint0_linear_15251_63610)"
      />
      <path
        d="M15.9973 7.9992c0 4.4178-3.5811 7.9992-7.9987 7.9992C3.5811 15.9984 0 12.417 0 7.9992S3.5811 0 7.9986 0c4.4176 0 7.9987 3.5814 7.9987 7.9992Z"
        fill="url(#paint1_radial_15251_63610)"
      />
      <path
        d="M7.9996 5.9081c-.3528-.8845-1.1936-1.507-2.1748-1.507-1.4323 0-2.4254 1.328-2.4254 2.6797 0 2.2718 2.3938 4.0094 4.0816 5.1589.3168.2157.7205.2157 1.0373 0 1.6878-1.1495 4.0815-2.8871 4.0815-5.159 0-1.3517-.993-2.6796-2.4254-2.6796-.9811 0-1.822.6225-2.1748 1.507Z"
        fill="#fff"
      />
    </g>
    <defs>
      <radialGradient
        id="paint1_radial_15251_63610"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 7.9992 -7.99863 0 7.9986 7.9992)"
      >
        <stop offset=".5637" stopColor="#E11731" stopOpacity="0" />
        <stop offset="1" stopColor="#E11731" stopOpacity=".1" />
      </radialGradient>
      <linearGradient
        id="paint0_linear_15251_63610"
        x1="2.3986"
        y1="2.4007"
        x2="13.5975"
        y2="13.5993"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF74AE" />
        <stop offset=".5001" stopColor="#FA2E3E" />
        <stop offset="1" stopColor="#FF5758" />
      </linearGradient>
      <clipPath id="clip0_15251_63610">
        <path fill="#fff" d="M-.001.0009h15.9992v15.9984H-.001z" />
      </clipPath>
    </defs>
  </svg>
)
